import React from 'react'
import { CreateSupportAnnounce10Container } from '../../containers/Officer/CreateSupportAnnounce10Container'
export const CreateSupportAnnounce10Page = () => {
    return (
        <CreateSupportAnnounce10Container />
    )
}
